import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import "../components/style.css";


import Axios from "axios";
import Swal from 'sweetalert2';
import Spinner from 'react-bootstrap/Spinner';
import jwt from "jsonwebtoken";
import { FaUser } from "react-icons/fa";
import bg from "../img/bg.png";
import dev1 from "../img/dev1.jpg";
import dev2 from "../img/dev2.jpg";
import dev3 from "../img/dev3.jpg";
import dev4 from "../img/dev4.jpg";
import dev5 from "../img/dev5.jpg";
import dev6 from "../img/dev6.jpg";
import dev7 from "../img/dev7.jpg";

require("moment/locale/th");

const ModalIntroduceDeveloper = ({ }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const navigate = useNavigate();
    // const localStorageToken_ = localStorage.getItem("Token_");
    // const Token_ = JSON.parse(localStorageToken_);
    // const DataToken_ = jwt.verify(Token_, process.env.REACT_APP_JWT);

    const Data = localStorage.getItem("DataLogin");
    const DataToken_ = JSON.parse(Data);

    const [loadingdownload, setloadingdownload] = useState(false);
    const [loadingdownloadSub, setloadingdownloadSub] = useState(false);
    const [datesub, setdatesub] = useState("");





    return (
        <>

            <Button className="btn btn-primary px-1 " style={{ height: "30px", verticalAlign: "middle" }} onClick={handleShow}>
                <div className="px-1" style={{ fontSize: "13px", }}>ทีมพัฒนาระบบ <FaUser /></div>

            </Button>





            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                centered
                keyboard={false}
            >
                <Modal.Header>
                    <button type="button" className="btn btn-primary custom-close-button " style={{ backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }} onClick={handleClose}>ปิด</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="rounded">

                        <div className="col-sm-12 col-xs-12">
                            <div className="card-body rounded ">
                                <div className="row d-flex ">
                                    <div className="col-3 col-xs-12 col-sm-12 card-title text-center fs-5 w-100 fs-3 " style={{
                                        backgroundImage: `url(${bg})`, backgroundRepeat: "no-repeat",
                                        backgroundSize: "100% 100%",
                                        backgroundSize: "cover",
                                        minHeight: "500px",
                                    }}>
                                        <div className="fw-bold " style={{ fontSize: "20px" }}>ทีมพัฒนาระบบ</div>
                                        <hr />
                                        <div className="justify-content-center ms-4">


                                            <div className="row col-12 col-sm-12  d-flex justify-content-center " style={{border:"2px solid RGB(255, 181, 69,0.90)",backgroundColor: "rgb(247, 247, 247, 0.5)"}}>
                                                <p className="fw-bold " style={{ fontSize: "18px", backgroundColor:"RGB(255, 181, 69,0.90)" }}>กพ.ทอ.
                                                </p>
                                                <div className="row col-12   mt-2 d-flex justify-content-center mb-2 " >

                                                    <div className="row col-12  col-6 col-lg-6  mt-2 d-flex justify-content-center ">
                                                        <div className="col-12 col-sm-4  d-flex justify-content-center">
                                                            <img src={dev6} alt="Profile" className="rounded-circle p-1 shadow bg-white" style={{ maxHeight: "120px", border: "0.5px solid grey" }} />
                                                        </div>
                                                        <div className="col-12 col-sm-8 d-flex align-items-center justify-content-center " style={{ fontSize: "14px" }}>
                                                            น.ท.อนุศาสน์ รู้อ่าน<br />
                                                            ฝสธ.กคพ.สปพ.กพ.ทอ.และ รรก.หน.ผคภ.กคพ.สปพ.กพ.ทอ. <br />
                                                        </div>
                                                    </div>
                                                    <div className="row col-12  col-6 col-lg-6  mt-2 d-flex justify-content-center ">
                                                        <div className="col-12 col-sm-4  d-flex justify-content-center">
                                                            <img src={dev7} alt="Profile" className="rounded-circle p-1 shadow bg-white" style={{ maxHeight: "120px", border: "0.5px solid grey" }} />
                                                        </div>
                                                        <div className="col-12 col-sm-8 d-flex align-items-center justify-content-center " style={{ fontSize: "14px" }}>
                                                            น.ต.ณเศรษฐ์ อึ๊งพลาชัย<br />
                                                            รอง หน.ผคภ.กคพ.สปพ.กพ.ทอ. <br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                            <div className="row col-12 col-sm-12  d-flex justify-content-center mt-2" style={{border:"2px solid RGB(255, 181, 69,0.90)",backgroundColor: "rgb(247, 247, 247, 0.5)"}}>
                                                <p className="fw-bold " style={{ fontSize: "18px",backgroundColor:"RGB(255, 181, 69,0.90)" }}>ศซว.ทอ.
                                                </p>
                                                <div className="row col-lg-12 justify-content-center d-flex ms-1">
                                                    <div className="row col-12   col-lg-6  mt-2 d-flex justify-content-center ">
                                                        <div className="col-12 col-sm-5  d-flex justify-content-center">
                                                            <img src={dev4} alt="Profile" className="rounded-circle p-1 shadow bg-white" style={{ maxHeight: "120px", border: "0.5px solid grey" }} />
                                                        </div>
                                                        <div className="col-12 col-sm-7 d-flex align-items-center justify-content-center " style={{ fontSize: "14px" }}>
                                                            น.อ.พงค์เทพ จันทน์เสนะ<br />
                                                            รอง ผอ.กบสซ.ศซว.ทอ. <br />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row col-lg-12 justify-content-center d-flex mb-2">

                                                    <div className="row col-12  col-6 col-lg-6  mt-2 d-flex justify-content-center ">
                                                        <div className="col-12 col-sm-4  d-flex justify-content-center">
                                                            <img src={dev2} alt="Profile" className="rounded-circle p-1 shadow bg-white" style={{ maxHeight: "120px", border: "0.5px solid grey" }} />
                                                        </div>
                                                        <div className="col-12 col-sm-8 d-flex align-items-center justify-content-center " style={{ fontSize: "14px" }}>
                                                            ร.ท.สิทธิชัย เยาวภักดิ์<br />
                                                            นปซ.ผบซ.กบสซ.ศซว.ทอ. <br />
                                                        </div>
                                                    </div>
                                                    <div className="row col-12  col-6 col-lg-6  mt-2 d-flex justify-content-center ">
                                                        <div className="col-12 col-sm-4  d-flex justify-content-center">
                                                            <img src={dev1} alt="Profile" className="rounded-circle p-1 shadow bg-white" style={{ maxHeight: "120px", border: "0.5px solid grey" }} />
                                                        </div>
                                                        <div className="col-12 col-sm-8 d-flex align-items-center justify-content-center " style={{ fontSize: "14px" }}>
                                                            จ.ต.หญิง ศศิวิมล สมศักดิ์<br />
                                                            จนท.ปข.ผปข.กบสซ.ศซว.ทอ. <br />
                                                        </div>
                                                    </div>
                                                    <div className="row col-12  col-6 col-lg-6  mt-2 d-flex justify-content-center">
                                                        <div className="col-12 col-sm-4  d-flex justify-content-center">
                                                            <img src={dev5} alt="Profile" className="rounded-circle p-1 shadow bg-white" style={{ maxHeight: "120px", border: "0.5px solid grey" }} />
                                                        </div>
                                                        <div className="col-12 col-sm-8 d-flex align-items-center justify-content-center " style={{ fontSize: "14px" }}>
                                                            จ.ท.ธนกฤต แก้วเรือนทอง<br />
                                                            จนท.ปซ.ผปซ.กบสซ.ศซว.ทอ. <br />
                                                        </div>
                                                    </div>
                                                    <div className="row col-12  col-6 col-lg-6  mt-2 d-flex justify-content-center">
                                                        <div className="col-12 col-sm-4  d-flex justify-content-center">
                                                            <img src={dev3} alt="Profile" className="rounded-circle p-1 shadow bg-white" style={{ maxHeight: "120px", border: "0.5px solid grey" }} />
                                                        </div>
                                                        <div className="col-12 col-sm-8 d-flex align-items-center justify-content-center " style={{ fontSize: "14px" }}>
                                                            น.ส.วรลักษณ์ เอมแย้ม<br />
                                                            พนักงานเขียนโปรแกรม ผบซ.กบสซ.ศซว.ทอ. <br />
                                                        </div>
                                                    </div>


                                                </div>
                                            </div></div>
                                        {/* <div className="row col-12 col-sm-8 borderred d-flex justify-content-center">
                                                <p>กพ.ทอ.
                                                </p>
                                                <div className="row col-12   mt-2 d-flex justify-content-center ">
                                                    <div className="col-12   d-flex justify-content-center">
                                                        <img src={dev6} alt="Profile" className="rounded-circle p-1 shadow bg-white" style={{ maxHeight: "120px", border: "0.5px solid grey" }} />
                                                    </div>
                                                    <div className="col-12  d-flex align-items-center justify-content-center " style={{ fontSize: "14px" }}>
                                                        น.ท.อนุศาสน์ รู้อ่าน<br />
                                                        ฝสธ.กคพ.สปพ.กพ.ทอ.และ รรก.หน.ผคภ.กคพ.สปพ.กพ.ทอ. <br />
                                                    </div>
                                                </div>

                                                <div className="row col-12    mt-2 d-flex justify-content-center ">
                                                    <div className="col-12   d-flex justify-content-center">
                                                        <img src={dev7} alt="Profile" className="rounded-circle p-1 shadow bg-white" style={{ maxHeight: "120px", border: "0.5px solid grey" }} />
                                                    </div>
                                                    <div className="col-12  d-flex align-items-center justify-content-center " style={{ fontSize: "14px" }}>
                                                        น.ต.ณเศรษฐ์ อึ๊งพลาชัย<br />
                                                        รอง หน.ผคภ.กคพ.สปพ.กพ.ทอ. <br />
                                                    </div>
                                                </div>
                                                </div> */}





                                    </div>

                                    <hr></hr>


                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

            </Modal>
        </>
    );
}

export default ModalIntroduceDeveloper
